module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container",
    attrs: {
      "id": "mobileViewPort"
    }
  }, [_c('div', {
    attrs: {
      "id": "mobileMode"
    }
  }, [_c('div', {
    attrs: {
      "id": "titleArea"
    }
  }, [_c('div', {
    staticClass: "titleText"
  }, [_vm._v("特殊成绩申请")]), _vm._v(" "), _c('div', {
    staticClass: "titleButton"
  }, [_c('el-button', {
    staticClass: "custom-el-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showHomePage
    }
  }, [_c('i', {
    staticClass: "el-icon-s-home"
  }), _vm._v(" 首页\n                ")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "queryArea"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "formItem"
  }, [(_vm.teaAuthVisible) ? _c('el-input', {
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stuAuthVisible) ? _c('el-input', {
    attrs: {
      "placeholder": "课程名称",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.courseName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "courseName", $$v)
      },
      expression: "queryForm.courseName"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "formItem text-center"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-more"
  }), _vm._v(" 更多")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.addRec
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" " + _vm._s(_vm.buttonName))])], 1)])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "queryDialog",
      "title": "查询信息",
      "width": "90%",
      "visible": _vm.queryDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.queryDialogVisible = $event
      }
    }
  }, [(_vm.teaAuthVisible) ? _c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "placeholder": "学年学期"
    },
    model: {
      value: (_vm.queryForm.semesterCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "semesterCode", $$v)
      },
      expression: "queryForm.semesterCode"
    }
  }, _vm._l((_vm.comboOption.semester), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-input', {
    attrs: {
      "placeholder": "课程名称"
    },
    model: {
      value: (_vm.queryForm.courseName),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "courseName", $$v)
      },
      expression: "queryForm.courseName"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "申请类型",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.applyTypeCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "applyTypeCode", $$v)
      },
      expression: "queryForm.applyTypeCode"
    }
  }, _vm._l((_vm.comboOption.applyType), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    attrs: {
      "placeholder": "审核状态",
      "clearable": ""
    },
    model: {
      value: (_vm.queryForm.auditState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "auditState", $$v)
      },
      expression: "queryForm.auditState"
    }
  }, _vm._l((_vm.comboOption.auditState), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_vm._v("查 询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重 置")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.queryDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "listArea"
    },
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.tableData == null || _vm.tableData.length == 0) ? _c('div', {
    staticClass: "cardTips"
  }, [_vm._v("没有特殊成绩申请记录")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "cardMain"
    }, [_c('div', {
      staticClass: "cardText"
    }, [_c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("学       号：")]), _vm._v(_vm._s(item.stuCode))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("姓       名：")]), _vm._v(_vm._s(item.stuName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("学年学期：")]), _vm._v(_vm._s(item.semesterName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("课程名称：")]), _vm._v(_vm._s(item.courseName))]), _vm._v(" "), _c('p', [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v("申请类型：")]), _vm._v(_vm._s(item.applyTypeName))]), _vm._v(" "), _c('div', {
      staticClass: "auditStateImg"
    }, [_c('img', {
      attrs: {
        "src": _vm.loadStateImg(item),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "cardInput"
    }, [(item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "warning"
      },
      on: {
        "click": function($event) {
          return _vm.modRec(item)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "success"
      },
      on: {
        "click": function($event) {
          return _vm.submitRec(item)
        }
      }
    }, [_vm._v("提交")]) : _vm._e(), _vm._v(" "), (item.submitState == '0') ? _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.delRec(item)
        }
      }
    }, [_vm._v("删除")]) : _vm._e(), _vm._v(" "), (item.submitState == '1' && item.auditAuth == '0') ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showDetailInfo(item)
        }
      }
    }, [_vm._v("详情")]) : _vm._e(), _vm._v(" "), (item.auditAuth == '1') ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.auditRec(item)
        }
      }
    }, [_vm._v("审核")]) : _vm._e(), _vm._v(" "), (item.submitState == '1' || item.auditState != '') ? _c('el-button', {
      on: {
        "click": function($event) {
          return _vm.showAuditList(item)
        }
      }
    }, [_vm._v("审核信息")]) : _vm._e()], 1)])
  }), _vm._v(" "), (_vm.total > 2 && _vm.total > _vm.tableData.length) ? _c('div', {
    attrs: {
      "id": "loadingTips"
    }
  }, [_c('i', {
    staticClass: "el-icon-loading"
  }), _vm._v(" 信息加载中，请稍候...\n            ")]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "id": "mainDialog",
      "title": _vm.dialogTitle,
      "visible": _vm.dialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "closed": _vm.closeDialog
    }
  }, [_c('el-scrollbar', {
    ref: "mainDialogScroll",
    attrs: {
      "id": "mainDialogScroll"
    }
  }, [_c('el-form', {
    ref: "specialScoreApplyForm",
    attrs: {
      "model": _vm.applyForm,
      "label-width": "100px",
      "label-position": "left",
      "width": "100%",
      "rules": _vm.curdRules
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "编号",
      "prop": "id"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.applyForm.id),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "id", $$v)
      },
      expression: "applyForm.id"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.teaAuthVisible && _vm.fieldVisible),
      expression: "teaAuthVisible && fieldVisible"
    }],
    attrs: {
      "label": "学生",
      "prop": "stuInfo"
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchStu,
      "placeholder": "可输入学号或姓名搜索学生",
      "trigger-on-focus": false,
      "clearable": ""
    },
    on: {
      "clear": _vm.clearSelectStu
    },
    model: {
      value: (_vm.stuInfo),
      callback: function($$v) {
        _vm.stuInfo = $$v
      },
      expression: "stuInfo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stuAuthVisible || !_vm.fieldVisible),
      expression: "stuAuthVisible || !fieldVisible"
    }],
    attrs: {
      "label": "学生",
      "prop": "stuCode"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.applyForm.stuCode + ' - ' + _vm.applyForm.stuName) + "\n                            "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    model: {
      value: (_vm.applyForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "stuCode", $$v)
      },
      expression: "applyForm.stuCode"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    model: {
      value: (_vm.applyForm.stuName),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "stuName", $$v)
      },
      expression: "applyForm.stuName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }],
    attrs: {
      "label": "学年学期",
      "prop": "semesterCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.semesterTips,
      "disabled": _vm.semesterDisable
    },
    on: {
      "change": _vm.handleSemesterChange
    },
    model: {
      value: (_vm.applyForm.semesterCode),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "semesterCode", $$v)
      },
      expression: "applyForm.semesterCode"
    }
  }, _vm._l((_vm.comboOption.semester), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "学年学期"
    }
  }, [_vm._v(_vm._s(_vm.applyForm.semesterName))])], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }],
    attrs: {
      "label": "申请课程",
      "prop": "relatedCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.courseTips,
      "disabled": _vm.courseDisable
    },
    on: {
      "change": _vm.handleCourseChange
    },
    model: {
      value: (_vm.applyForm.relatedCode),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "relatedCode", $$v)
      },
      expression: "applyForm.relatedCode"
    }
  }, _vm._l((_vm.comboOption.course), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "申请课程"
    }
  }, [_vm._v(_vm._s(_vm.applyForm.courseName))])], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }],
    attrs: {
      "label": "申请类型",
      "prop": "applyTypeCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.applyTypeTips,
      "disabled": _vm.applyTypeDisable
    },
    on: {
      "change": _vm.handleApplyTypeChange
    },
    model: {
      value: (_vm.applyForm.applyTypeCode),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "applyTypeCode", $$v)
      },
      expression: "applyForm.applyTypeCode"
    }
  }, _vm._l((_vm.comboOption.curApplyType), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "申请类型"
    }
  }, [_vm._v(_vm._s(_vm.applyForm.applyTypeName))])], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }],
    attrs: {
      "label": "成绩类型",
      "prop": "scoreType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.scoreTypeTips,
      "disabled": _vm.scoreTypeDisable
    },
    model: {
      value: (_vm.applyForm.scoreType),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "scoreType", $$v)
      },
      expression: "applyForm.scoreType"
    }
  }, _vm._l((_vm.comboOption.curScoreType), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "成绩类型"
    }
  }, [_vm._v(_vm._s(_vm.applyForm.scoreTypeName))])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.fileTableLoading),
      expression: "fileTableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fileTableData,
      "element-loading-text": "数据加载中",
      "height": _vm.fileTableHeight,
      "stripe": "",
      "border": "",
      "fit": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "附件",
      "prop": "fileName",
      "align": "center",
      "min-width": "40%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "110"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function(scope) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.attachmentOperateState),
            expression: "attachmentOperateState"
          }]
        }, [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.uploadDialogVisible = true
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v(" 上传")])], 1), _vm._v(" "), (!_vm.attachmentOperateState) ? _c('div', [_vm._v("操作")]) : _vm._e()]
      }
    }, {
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showAttachment(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        })]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.attachmentOperateState),
            expression: "attachmentOperateState"
          }],
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDelFile(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fieldVisible),
      expression: "fieldVisible"
    }],
    attrs: {
      "label": "申请理由",
      "prop": "applyReason"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写申请理由",
      "autoComplete": "on",
      "type": "textarea",
      "rows": 10,
      "show-word-limit": "",
      "maxlength": "200"
    },
    model: {
      value: (_vm.applyForm.applyReason),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "applyReason", $$v)
      },
      expression: "applyForm.applyReason"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fieldVisible),
      expression: "!fieldVisible"
    }],
    attrs: {
      "label": "申请理由"
    }
  }, [_vm._v(_vm._s(_vm.applyForm.applyReason))])], 1)], 1), _vm._v(" "), (_vm.auditAreaVisible) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('audit', {
    ref: "audit",
    attrs: {
      "itemCode": _vm.auditParam,
      "relatedCode": _vm.selectRowData ? _vm.selectRowData.id : '',
      "auditLevel": _vm.selectRowData ? _vm.selectRowData.auditLevel : ''
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fieldVisible) ? _c('div', {
    staticClass: "dialog-footer text-center",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.formSubmiting
    },
    on: {
      "click": _vm.saveRec
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "success",
      "disabled": _vm.formSubmiting
    },
    on: {
      "click": _vm.saveAndSubmitRec
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    staticStyle: {
      "top": "0"
    },
    attrs: {
      "title": "附件上传",
      "visible": _vm.uploadDialogVisible,
      "width": "90%",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.uploadDialogVisible = $event
      },
      "close": _vm.closeUploadDialog
    }
  }, [_c('div', {
    staticClass: "attachmentUpload",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-upload', {
    ref: "uploadFile",
    staticClass: "upload-demo",
    attrs: {
      "drag": "",
      "action": "#",
      "file-list": _vm.fileList,
      "http-request": _vm.getFile,
      "multiple": _vm.multipleType,
      "auto-upload": false,
      "limit": 10,
      "on-change": _vm.onChangeFile,
      "on-success": _vm.handleFilUploadSuccess,
      "on-remove": _vm.handleRemove,
      "on-exceed": _vm.handleExceed
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold"
    }
  }, [_c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "14px"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                                    允许上传的文件类型如下（单个文件大小" + _vm._s(_vm.fileSizeLimit) + "MB以内）"), _c('br'), _vm._v("\n                                    文本文件：txt、doc、docx、xls、xlsx、pdf、ppt、pptx"), _c('br'), _vm._v("\n                                    图片文件：jpg、jpeg、png、gif"), _c('br'), _vm._v("\n                                    音/视频文件：mp3、mp4\n                                ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": ""
    }
  }, [_vm._v("查看上传文件限制")])], 1)], 1)])])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleUpload
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeUploadDialog
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), (_vm.previewerDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": _vm.fileName,
      "visible": _vm.previewerDialogVisible,
      "width": "95%",
      "top": "10px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.previewerDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "730px"
    }
  }, [_c('previewer', {
    ref: "previewer",
    attrs: {
      "fileInfo": _vm.fileInfo,
      "height": 680
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.auditListDialogVisible) ? _c('el-dialog', {
    staticClass: "formDialog",
    attrs: {
      "title": "审核信息",
      "visible": _vm.auditListDialogVisible,
      "width": "90%"
    },
    on: {
      "update:visible": function($event) {
        _vm.auditListDialogVisible = $event
      }
    }
  }, [_c('div', [_c('auditList', {
    ref: "auditList",
    attrs: {
      "relatedCode": _vm.selectRowData.id,
      "listHeight": 450
    }
  })], 1)]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42655c70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/specialScoreApply.vue
// module id = 1818
// module chunks = 502